import { history } from '../redux/store';

export function irLoginEleccion() {
  localStorage.removeItem('token');
  history.push({ pathname: '/static/elecciones'});
}